export default __webpack_public_path__ + "static/media/ansible.5861a8cf.svg";